module.exports = __webpack_public_path__ + "static/img/logo_new.cc24e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_new.png
// module id = QrZs
// module chunks = 113